import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import { initSentry } from './sentry';
import { useAuthStore } from './stores/authStore';
import { ensureUserChannel } from './realtime/realtime';

initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>} showDialog>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
); 

// Bootstrap user channel subscription once user is known
useAuthStore.subscribe((state, prev) => {
  if (state.user?.id && state.user?.id !== prev?.user?.id) {
    ensureUserChannel(state.user.id).catch(() => {});
  }
});

// Also initialize immediately if user already present (e.g., restored from persistence)
const initialUser = useAuthStore.getState().user;
if (initialUser?.id) {
  ensureUserChannel(initialUser.id).catch(() => {});
}